import React, { useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import { isEmpty } from "lodash";
import "./register.css";

const useStyles = makeStyles({
  root: {
    height: "30px",
  },
  inputRoot: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "20px",
      height: "30px",
      fontSize: "14px",
      padding: "0px",
      color: "#ffffff",
      width: "500px",
      "& fieldset": {
        borderColor: "#5A9AB0",
      },
      "&:hover fieldset": {
        borderColor: "#5A9AB0",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#ffffff",
      },
      input: {
        paddingTop: "7px",
      },
      "& .MuiIconButton-root": {
        color: "#fff !important",
      },
    },
  },
  adornment: {
    color: "#fff",
  },
});

const AddCompany = ({
  handleClose,
  selectedList,
  listOfCompanies,
  selectCompany,
  handleInputChange,
}) => {
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(selectedList.length - 1);
  const classes = useStyles();

  const filterCompanies = (index) => {
    const selectedNamesAndCodes = selectedList.map((item) => item.companyId);
    return listOfCompanies.filter(
      (company) =>
        !selectedNamesAndCodes.includes(company.companyId)
    );
  };

  return (
    <div className="dialog">
      <div className="dialog-content">
        <div className="add-company-title">Select Company</div>
        <div className="aceTypeSelectBlock" key={selectedIndex}>
          <Autocomplete
            options={filterCompanies(selectedIndex)}
            getOptionLabel={(company) =>
              `${company.companyName} (${company.market}:${company.symbol})`
            }
            filterOptions={(options, state) => {
              const inputValue = state.inputValue.toLowerCase();
              return options.filter(
                (option) =>
                  option.companyName.toLowerCase().includes(inputValue) ||
                  option.symbol.toLowerCase().includes(inputValue)
              );
            }}
            value={selectedCompany}
            onChange={(event, newValue) => {
              setSelectedCompany(newValue);
            }}
            onInputChange={handleInputChange}
            classes={{ root: classes.root }}
            renderInput={(params) => (
              <React.Fragment>
                <TextField
                  {...params}
                  variant="outlined"
                  className={`sar-input ${classes.inputRoot}`}
                />
              </React.Fragment>
            )}
          />
        </div>
        <div className="add-company-btns">
          <button
            className="sar-btn"
            disabled={!selectedCompany || isEmpty(selectedCompany)}
            onClick={() => selectCompany(selectedCompany, selectedIndex)}
          >
            Add
          </button>
          <button className="sar-btn" onClick={handleClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddCompany;



// WEBPACK FOOTER //
// ./src/components/Register/addCompany.jsx